var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSokWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.76 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3,17.4l-4.5-4.5a.1.1,0,0,1-.1-.1,8.19,8.19,0,0,0-.9-10.4,8,8,0,0,0-11.4,0,8,8,0,0,0,0,11.4,8.18,8.18,0,0,0,10.4.9.1.1,0,0,0,.1.1l4.5,4.5a1.45,1.45,0,0,0,2,0A1.31,1.31,0,0,0,19.3,17.4ZM4.2,12.2a5.59,5.59,0,0,1,7.9-7.9,5.59,5.59,0,0,1-7.9,7.9Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSokWhite);
export default __webpack_public_path__ + "static/media/sok-white.7d28ee75b4cd9d31cf83be8a9ea25e0f.svg";
export { ForwardRef as ReactComponent };